import { IExerciseResultItem } from '../redux/api/exercises/interfaces';
import {
  useGetExerciseResults,
  useGetExerciseResultsForUser,
} from '../redux/api/exercisesAPI';

export function useExerciseResultsForSetAutofill(
  otherUserIdForResults: string | undefined | null,
  options?: { skip?: boolean },
): IExerciseResultItem[] | undefined {
  const skipOuter = options?.skip === true;
  const hasOtherUser = Boolean(otherUserIdForResults);

  const { data: ownResults } = useGetExerciseResults(undefined, {
    skip: skipOuter || hasOtherUser,
  });

  const { data: otherUserResults } = useGetExerciseResultsForUser(
    otherUserIdForResults ?? '',
    {
      skip: skipOuter || !hasOtherUser,
    },
  );

  return hasOtherUser ? otherUserResults : ownResults;
}
